import { useState } from 'react';

interface Props {
  optionDepth: number;
}

export const useSelectorOptionFilter = ({ optionDepth }: Props) => {
  const initialFilters = Array(optionDepth + 1).fill('');
  const [filters, setFilters] = useState(initialFilters);

  const clearFilters = () => setFilters(initialFilters);
  const clearChildrenFilters = (level: number) => {
    setFilters((prev) => {
      for (let i = level + 1; i < prev.length; i++) {
        prev[i] = '';
      }
      return [...prev];
    });
  };

  return {
    filters,
    setFilters,
    clearFilters,
    clearChildrenFilters,
  };
};
